// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AllTopUps_allTopUpsContainer__4RINs {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 20px;
}

.AllTopUps_sectionTitle__28NQ9 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.AllTopUps_sectionSubtitle__LNe2i {
  text-align: center;
  font-size: 1.1rem;
  color: #666;
  margin-bottom: 48px;
}

.AllTopUps_topUpCardsContainer__yJ7Si {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 30px;
  margin-bottom: 32px;
}

.AllTopUps_topUpCard__rTje3 {
  background: white;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.AllTopUps_topUpCard__rTje3:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
}

.AllTopUps_cardIcon__dxLbK {
  font-size: 3rem;
  margin-bottom: 16px;
}

.AllTopUps_cardTitle__5tLUE {
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 12px;
  color: #333;
}

.AllTopUps_cardDescription__w3j\\+S {
  color: #666;
  line-height: 1.5;
  margin-bottom: 24px;
}

.AllTopUps_pricingOptions__Ga860 {
  margin-bottom: 28px;
}

.AllTopUps_priceOption__UtvFL {
  padding: 12px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.AllTopUps_priceOption__UtvFL:last-child {
  border-bottom: none;
}

.AllTopUps_price__nbXJD {
  font-size: 1.25rem;
  font-weight: 700;
  color: #667eea;
}

.AllTopUps_quantity__wBK6f {
  font-weight: 500;
  color: #333;
}

.AllTopUps_perUnit__sSYP2 {
  font-size: 0.85rem;
  color: #999;
}

.AllTopUps_topUpButton__3Jwr0 {
  width: 100%;
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.AllTopUps_topUpButton__3Jwr0:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.AllTopUps_infoNote__AcMyI {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff3cd;
  border-left: 4px solid #ffc107;
  padding: 16px;
  border-radius: 8px;
  margin-top: 32px;
}

.AllTopUps_infoIcon__\\+bSPq {
  font-size: 1.25rem;
}

.AllTopUps_infoNote__AcMyI p {
  margin: 0;
  color: #856404;
  font-size: 0.9rem;
  line-height: 1.5;
}

/* Modal Styles */
.AllTopUps_modalOverlay__5SjZU {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: AllTopUps_fadeIn__b3oIc 0.3s ease;
}

.AllTopUps_modalContent__5dU2w {
  background: white;
  border-radius: 20px;
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: AllTopUps_slideUp__JyVx\\+ 0.3s ease;
}

.AllTopUps_modalHeader__mxJgz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
}

.AllTopUps_modalHeader__mxJgz h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.AllTopUps_modalClose__pkOeq {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #999;
  transition: color 0.2s ease;
}

.AllTopUps_modalClose__pkOeq:hover {
  color: #333;
}

.AllTopUps_modalBody__W6a3p {
  padding: 24px;
}

.AllTopUps_topUpOptions__SCiCr {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.AllTopUps_topUpOption__1B85F {
  padding: 20px;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.AllTopUps_topUpOption__1B85F:hover {
  border-color: #667eea;
  transform: translateX(5px);
}

.AllTopUps_topUpOption__1B85F.AllTopUps_selected__VslB\\+ {
  border-color: #667eea;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);
}

.AllTopUps_optionPrice__hHuzB {
  font-size: 1.5rem;
  font-weight: 700;
  color: #667eea;
  margin-bottom: 8px;
}

.AllTopUps_optionMessages__7WcUD {
  font-size: 1rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.AllTopUps_optionPerMessage__FsTDI {
  font-size: 0.85rem;
  color: #999;
}

.AllTopUps_selectedBadge__GWtpg {
  position: absolute;
  top: 12px;
  right: 12px;
  background: #667eea;
  color: white;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.AllTopUps_checkoutContainer__26koI {
  margin-top: 24px;
}

/* Animations */
@keyframes AllTopUps_fadeIn__b3oIc {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes AllTopUps_slideUp__JyVx\\+ {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .AllTopUps_topUpCardsContainer__yJ7Si {
    grid-template-columns: 1fr;
  }
  
  .AllTopUps_sectionTitle__28NQ9 {
    font-size: 1.75rem;
  }
  
  .AllTopUps_cardTitle__5tLUE {
    font-size: 1.5rem;
  }
  
  .AllTopUps_priceOption__UtvFL {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .AllTopUps_modalContent__5dU2w {
    width: 95%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Component/app_components/AllTopUps.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4CAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,8CAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gGAAgG;AAClG;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".allTopUpsContainer {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  border-radius: 20px;\n}\n\n.sectionTitle {\n  text-align: center;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 16px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.sectionSubtitle {\n  text-align: center;\n  font-size: 1.1rem;\n  color: #666;\n  margin-bottom: 48px;\n}\n\n.topUpCardsContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));\n  gap: 30px;\n  margin-bottom: 32px;\n}\n\n.topUpCard {\n  background: white;\n  border-radius: 16px;\n  padding: 32px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.topUpCard:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);\n}\n\n.cardIcon {\n  font-size: 3rem;\n  margin-bottom: 16px;\n}\n\n.cardTitle {\n  font-size: 1.75rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n  color: #333;\n}\n\n.cardDescription {\n  color: #666;\n  line-height: 1.5;\n  margin-bottom: 24px;\n}\n\n.pricingOptions {\n  margin-bottom: 28px;\n}\n\n.priceOption {\n  padding: 12px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.priceOption:last-child {\n  border-bottom: none;\n}\n\n.price {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #667eea;\n}\n\n.quantity {\n  font-weight: 500;\n  color: #333;\n}\n\n.perUnit {\n  font-size: 0.85rem;\n  color: #999;\n}\n\n.topUpButton {\n  width: 100%;\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.topUpButton:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);\n}\n\n.infoNote {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  background: #fff3cd;\n  border-left: 4px solid #ffc107;\n  padding: 16px;\n  border-radius: 8px;\n  margin-top: 32px;\n}\n\n.infoIcon {\n  font-size: 1.25rem;\n}\n\n.infoNote p {\n  margin: 0;\n  color: #856404;\n  font-size: 0.9rem;\n  line-height: 1.5;\n}\n\n/* Modal Styles */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.3s ease;\n}\n\n.modalContent {\n  background: white;\n  border-radius: 20px;\n  max-width: 600px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp 0.3s ease;\n}\n\n.modalHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 24px;\n  border-bottom: 1px solid #eee;\n}\n\n.modalHeader h3 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.modalClose {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: #999;\n  transition: color 0.2s ease;\n}\n\n.modalClose:hover {\n  color: #333;\n}\n\n.modalBody {\n  padding: 24px;\n}\n\n.topUpOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.topUpOption {\n  padding: 20px;\n  border: 2px solid #e0e0e0;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.topUpOption:hover {\n  border-color: #667eea;\n  transform: translateX(5px);\n}\n\n.topUpOption.selected {\n  border-color: #667eea;\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%);\n}\n\n.optionPrice {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #667eea;\n  margin-bottom: 8px;\n}\n\n.optionMessages {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 4px;\n}\n\n.optionPerMessage {\n  font-size: 0.85rem;\n  color: #999;\n}\n\n.selectedBadge {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: #667eea;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.checkoutContainer {\n  margin-top: 24px;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .topUpCardsContainer {\n    grid-template-columns: 1fr;\n  }\n  \n  .sectionTitle {\n    font-size: 1.75rem;\n  }\n  \n  .cardTitle {\n    font-size: 1.5rem;\n  }\n  \n  .priceOption {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .modalContent {\n    width: 95%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"allTopUpsContainer": `AllTopUps_allTopUpsContainer__4RINs`,
	"sectionTitle": `AllTopUps_sectionTitle__28NQ9`,
	"sectionSubtitle": `AllTopUps_sectionSubtitle__LNe2i`,
	"topUpCardsContainer": `AllTopUps_topUpCardsContainer__yJ7Si`,
	"topUpCard": `AllTopUps_topUpCard__rTje3`,
	"cardIcon": `AllTopUps_cardIcon__dxLbK`,
	"cardTitle": `AllTopUps_cardTitle__5tLUE`,
	"cardDescription": `AllTopUps_cardDescription__w3j+S`,
	"pricingOptions": `AllTopUps_pricingOptions__Ga860`,
	"priceOption": `AllTopUps_priceOption__UtvFL`,
	"price": `AllTopUps_price__nbXJD`,
	"quantity": `AllTopUps_quantity__wBK6f`,
	"perUnit": `AllTopUps_perUnit__sSYP2`,
	"topUpButton": `AllTopUps_topUpButton__3Jwr0`,
	"infoNote": `AllTopUps_infoNote__AcMyI`,
	"infoIcon": `AllTopUps_infoIcon__+bSPq`,
	"modalOverlay": `AllTopUps_modalOverlay__5SjZU`,
	"fadeIn": `AllTopUps_fadeIn__b3oIc`,
	"modalContent": `AllTopUps_modalContent__5dU2w`,
	"slideUp": `AllTopUps_slideUp__JyVx+`,
	"modalHeader": `AllTopUps_modalHeader__mxJgz`,
	"modalClose": `AllTopUps_modalClose__pkOeq`,
	"modalBody": `AllTopUps_modalBody__W6a3p`,
	"topUpOptions": `AllTopUps_topUpOptions__SCiCr`,
	"topUpOption": `AllTopUps_topUpOption__1B85F`,
	"selected": `AllTopUps_selected__VslB+`,
	"optionPrice": `AllTopUps_optionPrice__hHuzB`,
	"optionMessages": `AllTopUps_optionMessages__7WcUD`,
	"optionPerMessage": `AllTopUps_optionPerMessage__FsTDI`,
	"selectedBadge": `AllTopUps_selectedBadge__GWtpg`,
	"checkoutContainer": `AllTopUps_checkoutContainer__26koI`
};
export default ___CSS_LOADER_EXPORT___;
